export default __webpack_public_path__ + "static/media/manni-dee.95810a28.jpg";